<template>
  <div style="padding:15px;">
    <keep-alive :include="['WaybillManage', 'InlineEditTable']">
      <router-view />
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: "TransportManageLayout"
};
</script>
